import type { ToolMeta } from "../types";

export const toolMeta = {
  slug: "scroll-animator-studio",
  title: "Scroll Animator Studio",
  description:
    "Design scroll-driven container timelines visually, preview them in the browser, and export a ready-to-edit HTML, CSS, and JavaScript project or React code.",
  seoTitle: "Scroll Animator Studio - No Gatekeeping",
  seoDescription:
    "Build scroll-driven web animations with a visual stage, timeline keyframes, easing controls, live preview, and production-ready code export.",
  featureList: [
    "Visual scroll animation stage",
    "Solid-color blank layout containers",
    "Timeline milestones and cubic-bezier easing",
    "Starter animation templates",
    "Live scroll preview",
    "Linked index.html, style.css, and script.js project export",
  ],
  category: "Design",
} satisfies ToolMeta;
